function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.736 6.652h2.323V4.44a.44.44 0 00-.616-.402l-3.15 1.378V4.44a.44.44 0 00-.615-.402l-2.243.981.453 4.236c.349-.874 1.511-2.603 3.848-2.603zM6.403 3.64H1.066L.003 13.572a.44.44 0 00.436.486h6.59a.44.44 0 00.437-.486L6.403 3.64zM6.054.392A.44.44 0 005.618 0H1.852a.44.44 0 00-.437.392l-.254 2.37h5.148L6.054.392z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.56 7.531h-2.824a3.261 3.261 0 00-3.263 3.264v2.642l2.952-2.953a.44.44 0 11.622.621l-2.953 2.953h2.642A3.261 3.261 0 0015 10.795V7.97a.44.44 0 00-.44-.439z",
  fill: "#fff"
});

function SvgIconProspectsSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconProspectsSmall;